import { useState } from 'react';
import { SubAccount, SubAccountsRequest, PaginationMetaData } from 'vopay';
import { useApi } from '#shared/providers/Api';

const INITIAL_PAGINATION: PaginationMetaData = {
  TotalRecords: 0,
  Limit: 0,
  Offset: 0,
};

// Direct-Pattern reimplementation of client-dashboard's legacy useFetchSubAccounts (ID-13193), so shared's
// SubAccountList and the host apps consume one hook. Wraps the host-injected api's fetchSubAccounts via
// useApi(); stores the envelope-free data (the SubAccount list, parent-account label and pagination), never
// the *Response carrying Success/ErrorMessage. No CancelToken; loading UI is raised by the consuming
// component (loading-conventions), never here. The list and the org-chart each instantiate their own copy.
export default function useSubAccounts() {
  const api = useApi();
  const [fetchingSubAccounts, setFetchingSubAccounts] = useState(false);
  const [subAccounts, setSubAccounts] = useState<SubAccount[]>([]);
  const [parentAccount, setParentAccount] = useState('');
  const [pagination, setPagination] = useState<PaginationMetaData>(INITIAL_PAGINATION);

  async function fetchSubAccounts(params: SubAccountsRequest) {
    try {
      setFetchingSubAccounts(true);
      const res = await api.fetchSubAccounts(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setSubAccounts(res.Subaccounts);
      setParentAccount(res.ParentAccount);
      setPagination(res.PaginationMetaData ?? INITIAL_PAGINATION);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetchingSubAccounts(false);
    }
  }

  return { fetchingSubAccounts, subAccounts, parentAccount, pagination, fetchSubAccounts };
}
